import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=73c60c93&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=73c60c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c60c93",
  null
  
)

export default component.exports